import { useMemo, useReducer } from 'react';
import { initialUserSettingsState } from '../types/userTypes';
import { featureFlagsReducer } from './featureFlagsReducer';
import { modalReducer } from './modalReducer';
import { holidayReducer, initialFeatureFlagsState, initialHolidayState, initialModalState, userSettingsReducer, } from './reducer';
export const useAbdooReducer = () => {
    const [modalState, modalDispatch] = useReducer(modalReducer, initialModalState);
    const [holidayState, holidayDispatch] = useReducer(holidayReducer, initialHolidayState);
    const [userSettingsState, userSettingsDispatch] = useReducer(userSettingsReducer, initialUserSettingsState);
    const [featureFlagsState, featureFlagsDispatch] = useReducer(featureFlagsReducer, initialFeatureFlagsState);
    return useMemo(() => {
        return {
            holidayState,
            holidayDispatch,
            modalState,
            modalDispatch,
            userSettingsState,
            userSettingsDispatch,
            featureFlagsState,
            featureFlagsDispatch,
        };
    }, [
        holidayState,
        holidayDispatch,
        modalState,
        modalDispatch,
        userSettingsState,
        userSettingsDispatch,
        featureFlagsState,
        featureFlagsDispatch,
    ]);
};
